
export default {
  name: 'AllFurnitureViewMiddleSubCategory',
  data() {
    return {
      placeholder: 'js/productlisting/assets/placeholder-animation.svg',
      isImgLoaded: false,
    };
  },
  props: {
    subCategory: {
      type: Object,
      required: true,
    },
  },
  methods: {
    load() {
      const img = this.$refs.imageContainer.querySelector('img');
      if (!img.getAttribute('src').includes('data:image')) {
        this.isImgLoaded = true;
      }
    },
  },
};
